import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingBag, Search, Menu, X, Instagram } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { NAV_LINKS, SOCIAL_LINKS } from '../mock/mock';

export default function Navbar() {
  const { count, setOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const handleNav = (e, href) => {
    e.preventDefault();
    setMobileOpen(false);
    if (href.startsWith('/#')) {
      navigate('/');
      setTimeout(() => {
        const id = href.replace('/#', '');
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 60);
    } else {
      navigate(href);
      window.scrollTo(0, 0);
    }
  };

  return (
    <header className="sticky top-0 z-40 backdrop-blur-md border-b border-cream/10" style={{backgroundColor: 'rgba(0,0,0,0.95)'}}>
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <div className="flex items-center justify-between h-[82px] md:h-[104px]">
          {/* Left: Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/77loiwsl_4ece5f13-27f5-4ece-82ec-d7db4259eac7%20-%20Edited.png"
              alt="Mariah Angeliq"
              className="h-[70px] md:h-[92px] w-auto object-contain"
            />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-9">
            {NAV_LINKS.map((l) => (
              <a key={l.label} href={l.href} onClick={(e) => handleNav(e, l.href)}
                className="font-body text-sm uppercase tracking-[0.18em] text-cream link-underline">
                {l.label}
              </a>
            ))}
          </nav>

          {/* Right: icons */}
          <div className="flex items-center gap-4">
            <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noreferrer" className="hidden md:inline-flex text-cream hover:text-gold transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <button aria-label="search" className="hidden md:inline-flex text-cream hover:text-gold transition-colors">
              <Search className="w-5 h-5" />
            </button>
            <button onClick={() => setOpen(true)} className="relative text-cream hover:text-gold transition-colors">
              <ShoppingBag className="w-5 h-5" />
              {count > 0 && (
                <span className="absolute -top-2 -right-2 bg-gold text-brown text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center">{count}</span>
              )}
            </button>
            <button onClick={() => setMobileOpen((s) => !s)} className="md:hidden text-cream">
              {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile nav drawer */}
      {mobileOpen && (
        <div className="md:hidden bg-brown border-t border-cream/10">
          <div className="flex flex-col gap-1 p-5">
            {NAV_LINKS.map((l) => (
              <a key={l.label} href={l.href} onClick={(e) => handleNav(e, l.href)}
                className="font-display text-3xl text-cream uppercase py-2">
                {l.label}
              </a>
            ))}
            <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noreferrer"
              className="font-body text-sm uppercase tracking-widest text-cream mt-4 inline-flex items-center gap-2">
              <Instagram className="w-4 h-4" /> @mariahangeliq
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
